import { render, staticRenderFns } from "./FirstAidVideo_release.vue?vue&type=template&id=2bee796f&"
import script from "./FirstAidVideo_release.vue?vue&type=script&lang=js&"
export * from "./FirstAidVideo_release.vue?vue&type=script&lang=js&"
import style0 from "./FirstAidVideo_release.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports